import { Navigate, Route, useParams } from "react-router-dom";
import ClientPortalLayout from "./ClientPortalLayout";
import { ClientPortalBaseProvider } from "../../hooks/useClientPortalBase";
import {
  CASAMAPA_ADMIN_PORTAL_BASE,
  CLIENT_ADMIN_PORTAL_LEGACY_BASE,
  MIDPOINT_MEDIA_ADMIN_PORTAL_BASE,
} from "../../constants/clientAdminPortalRoutes";
import ClientLoginPage from "../../pages/client/ClientLoginPage";
import ClientAcceptInvitationPage from "../../pages/client/ClientAcceptInvitationPage";
import ClientResetPasswordPage from "../../pages/client/ClientResetPasswordPage";
import ClientChangePasswordPage from "../../pages/client/ClientChangePasswordPage";
import ClientLogoutPage from "../../pages/client/ClientLogoutPage";
import ClientDashboardPage from "../../pages/client/ClientDashboardPage";
import ClientCommunitiesListPage from "../../pages/client/ClientCommunitiesListPage";
import ClientCommunityFormPage from "../../pages/client/ClientCommunityFormPage";
import ClientCommunityPreviewPage from "../../pages/client/ClientCommunityPreviewPage";
import ClientCommunityDetailPage from "../../pages/client/ClientCommunityDetailPage";
import ClientCoursesListPage from "../../pages/client/ClientCoursesListPage";
import ClientCourseFormPage from "../../pages/client/ClientCourseFormPage";
import ClientCoursePreviewPage from "../../pages/client/ClientCoursePreviewPage";
import ClientCourseDetailPage from "../../pages/client/ClientCourseDetailPage";
import ClientAnalyticsPage from "../../pages/client/ClientAnalyticsPage";
import ClientReportsHubPage from "../../pages/client/ClientReportsHubPage";
import ClientOpportunityReportPage from "../../pages/client/ClientOpportunityReportPage";
import ClientCommunityReportPage from "../../pages/client/ClientCommunityReportPage";
import ClientCourseReportPage from "../../pages/client/ClientCourseReportPage";
import ClientSourceReportPage from "../../pages/client/ClientSourceReportPage";
import ClientOpportunitiesListPage from "../../pages/client/ClientOpportunitiesListPage";
import ClientOpportunityDetailPage from "../../pages/client/ClientOpportunityDetailPage";
import ClientRealtorsVendorsPage from "../../pages/client/ClientRealtorsVendorsPage";
import ClientVendorDetailPage from "../../pages/client/ClientVendorDetailPage";
import ClientVendorDirectoryHubPage from "../../pages/client/ClientVendorDirectoryHubPage";
import ClientPublishingPage from "../../pages/client/ClientPublishingPage";
import ClientSettingsPage from "../../pages/client/ClientSettingsPage";
import ClientSettingsHubLayout from "./ClientSettingsHubLayout";
import ClientSettingsDataSourcesPage from "../../pages/client/ClientSettingsDataSourcesPage";
import ClientSettingsAuditPage from "../../pages/client/ClientSettingsAuditPage";
import ClientSettingsNotificationsPage from "../../pages/client/ClientSettingsNotificationsPage";
import ClientSettingsNotificationEditorPage from "../../pages/client/ClientSettingsNotificationEditorPage";
import CasaMapaAdminDashboardPage from "../../pages/casamapa/admin/CasaMapaAdminDashboardPage";
import CasaMapaAdminLeadsPage from "../../pages/casamapa/admin/CasaMapaAdminLeadsPage";
import CasaMapaAdminAgenciesPage from "../../pages/casamapa/admin/CasaMapaAdminAgenciesPage";
import CasaMapaAdminAgencyCreatePage from "../../pages/casamapa/admin/CasaMapaAdminAgencyCreatePage";
import CasaMapaAdminAgencyDetailPage from "../../pages/casamapa/admin/CasaMapaAdminAgencyDetailPage";
import CasaMapaAdminListingsPage from "../../pages/casamapa/admin/CasaMapaAdminListingsPage";
import CasaMapaAdminPropertyLinkingPage from "../../pages/casamapa/admin/CasaMapaAdminPropertyLinkingPage";
import CasaMapaAdminMarketTrendsPage from "../../pages/casamapa/admin/CasaMapaAdminMarketTrendsPage";
import CasaMapaAdminPublicInventoryPage from "../../pages/casamapa/admin/CasaMapaAdminPublicInventoryPage";
import CasaMapaAdminListingDetailPage from "../../pages/casamapa/admin/CasaMapaAdminListingDetailPage";
import CasaMapaAdminListingDataHealthPage from "../../pages/casamapa/admin/CasaMapaAdminListingDataHealthPage";
import CasaMapaAdminVendorsPage from "../../pages/casamapa/admin/CasaMapaAdminVendorsPage";
import CasaMapaAdminIamPage from "../../pages/casamapa/admin/CasaMapaAdminIamPage";
import CasaMapaAdminAnalyticsLayout from "../casamapa/admin/CasaMapaAdminAnalyticsLayout";
import CasaMapaAdminWebsiteAnalyticsPage from "../../pages/casamapa/admin/CasaMapaAdminWebsiteAnalyticsPage";
import CasaMapaAdminMarketAnalysisPage from "../../pages/casamapa/admin/CasaMapaAdminMarketAnalysisPage";
import CasaMapaAdminPropertyValuationPage from "../../pages/casamapa/admin/CasaMapaAdminPropertyValuationPage";
import CasaMapaAdminInvestmentAnalysisPage from "../../pages/casamapa/admin/CasaMapaAdminInvestmentAnalysisPage";
import CasaMapaAdminVendorWorkspaceLayout from "../casamapa/admin/CasaMapaAdminVendorWorkspaceLayout";
import { partnerVendorDirectoryRouteElements } from "../partner/PartnerVendorDirectoryRoutes";
import MidpointMediaAdminDashboardPage from "../../pages/midpointMedia/admin/MidpointMediaAdminDashboardPage";
import MidpointMediaAdminCrmHubPage from "../../pages/midpointMedia/admin/MidpointMediaAdminCrmHubPage";
import MidpointMediaAdminCrmLeadsPage from "../../pages/midpointMedia/admin/MidpointMediaAdminCrmLeadsPage";
import MidpointMediaAdminCrmLeadDetailPage from "../../pages/midpointMedia/admin/MidpointMediaAdminCrmLeadDetailPage";
import MidpointMediaAdminPeoplePage from "../../pages/midpointMedia/admin/MidpointMediaAdminPeoplePage";
import MidpointMediaAdminPeopleApplicationsPage from "../../pages/midpointMedia/admin/MidpointMediaAdminPeopleApplicationsPage";
import MidpointMediaAdminPeopleAccountsPage from "../../pages/midpointMedia/admin/MidpointMediaAdminPeopleAccountsPage";
import MidpointMediaAdminPeopleSchedulesPage from "../../pages/midpointMedia/admin/MidpointMediaAdminPeopleSchedulesPage";
import MidpointMediaAdminInfrastructurePage from "../../pages/midpointMedia/admin/MidpointMediaAdminInfrastructurePage";
import MidpointMediaAdminProjectsPage from "../../pages/midpointMedia/admin/MidpointMediaAdminProjectsPage";

function CasaMapaAdminAgencyInventoryRedirect() {
  const { agencySlug } = useParams();
  return <Navigate to={`../listings?agencySlug=${encodeURIComponent(agencySlug || "")}`} replace />;
}

function ClientAdminPortalAuthRoutes({ base }) {
  return (
    <ClientPortalBaseProvider base={base}>
      <ClientLoginPage />
    </ClientPortalBaseProvider>
  );
}

function ClientAdminPortalAcceptRoutes({ base }) {
  return (
    <ClientPortalBaseProvider base={base}>
      <ClientAcceptInvitationPage />
    </ClientPortalBaseProvider>
  );
}

function ClientAdminPortalResetPasswordRoutes({ base }) {
  return (
    <ClientPortalBaseProvider base={base}>
      <ClientResetPasswordPage />
    </ClientPortalBaseProvider>
  );
}

function ClientAdminPortalLogoutRoutes({ base }) {
  return (
    <ClientPortalBaseProvider base={base}>
      <ClientLogoutPage />
    </ClientPortalBaseProvider>
  );
}

function ClientAdminPortalLayoutRoutes({ base }) {
  return (
    <ClientPortalBaseProvider base={base}>
      <ClientPortalLayout />
    </ClientPortalBaseProvider>
  );
}

/**
 * Mount the shared client administrative portal at a product base path.
 * Used for legacy `/client` and CasaMapa `/v/casamapa/admin`.
 */
export function ClientAdminPortalRouteGroup(base) {
  const root = base.replace(/\/+$/, "");
  const isCasaMapaPortal = root === CASAMAPA_ADMIN_PORTAL_BASE;
  const isMidpointMediaPortal = root === MIDPOINT_MEDIA_ADMIN_PORTAL_BASE;
  const DashboardPage = isCasaMapaPortal
    ? CasaMapaAdminDashboardPage
    : isMidpointMediaPortal
      ? MidpointMediaAdminDashboardPage
      : ClientDashboardPage;

  return (
    <>
      <Route path={`${root}/login`} element={<ClientAdminPortalAuthRoutes base={root} />} />
      <Route
        path={`${root}/accept-invitation`}
        element={<ClientAdminPortalAcceptRoutes base={root} />}
      />
      <Route
        path={`${root}/reset-password`}
        element={<ClientAdminPortalResetPasswordRoutes base={root} />}
      />
      <Route path={`${root}/logout`} element={<ClientAdminPortalLogoutRoutes base={root} />} />
      <Route path={root} element={<ClientAdminPortalLayoutRoutes base={root} />}>
        <Route index element={<Navigate to={`${root}/dashboard`} replace />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="change-password" element={<ClientChangePasswordPage />} />
        {isMidpointMediaPortal ? (
          <>
            <Route path="crm" element={<MidpointMediaAdminCrmHubPage />} />
            <Route path="crm/leads" element={<MidpointMediaAdminCrmLeadsPage />} />
            <Route path="crm/leads/:leadId" element={<MidpointMediaAdminCrmLeadDetailPage />} />
            <Route path="people" element={<MidpointMediaAdminPeoplePage />} />
            <Route path="people/applications" element={<MidpointMediaAdminPeopleApplicationsPage />} />
            <Route path="people/accounts" element={<MidpointMediaAdminPeopleAccountsPage />} />
            <Route path="people/schedules" element={<MidpointMediaAdminPeopleSchedulesPage />} />
            <Route path="infrastructure" element={<MidpointMediaAdminInfrastructurePage />} />
            <Route path="projects" element={<MidpointMediaAdminProjectsPage />} />
          </>
        ) : null}
        {isCasaMapaPortal ? (
          <>
            <Route path="agencies" element={<CasaMapaAdminAgenciesPage />} />
            <Route path="agencies/new" element={<CasaMapaAdminAgencyCreatePage />} />
            <Route path="agencies/:agencySlug/inventory" element={<CasaMapaAdminAgencyInventoryRedirect />} />
            <Route path="agencies/:agencySlug" element={<CasaMapaAdminAgencyDetailPage />} />
            <Route path="listings" element={<CasaMapaAdminListingsPage />} />
            <Route path="public-inventory" element={<CasaMapaAdminPublicInventoryPage />} />
            <Route path="property-linking" element={<CasaMapaAdminPropertyLinkingPage />} />
            <Route path="market-trends" element={<CasaMapaAdminMarketTrendsPage />} />
            <Route path="listings/:listingId/data-health" element={<CasaMapaAdminListingDataHealthPage />} />
            <Route path="listings/:listingId" element={<CasaMapaAdminListingDetailPage />} />
            <Route path="vendors" element={<CasaMapaAdminVendorsPage />} />
            <Route path="iam" element={<CasaMapaAdminIamPage />} />
            <Route path="analytics" element={<CasaMapaAdminAnalyticsLayout />}>
              <Route index element={<Navigate to="website" replace />} />
              <Route path="website" element={<CasaMapaAdminWebsiteAnalyticsPage />} />
              <Route path="market" element={<CasaMapaAdminMarketAnalysisPage />} />
              <Route path="valuation" element={<CasaMapaAdminPropertyValuationPage />} />
              <Route path="investment" element={<CasaMapaAdminInvestmentAnalysisPage />} />
            </Route>
            <Route path="vendors/workspace/:clientViewId" element={<CasaMapaAdminVendorWorkspaceLayout />}>
              {partnerVendorDirectoryRouteElements()}
            </Route>
          </>
        ) : null}
        <Route path="views" element={<Navigate to={`${root}/dashboard`} replace />} />
        <Route path="views/:clientViewId" element={<Navigate to={`${root}/dashboard`} replace />} />
        {isMidpointMediaPortal ? null : (
          <>
            <Route path="views/:clientViewId/communities" element={<ClientCommunitiesListPage />} />
            <Route path="views/:clientViewId/communities/new" element={<ClientCommunityFormPage />} />
            <Route
              path="views/:clientViewId/communities/:communityId/edit"
              element={<ClientCommunityFormPage />}
            />
            <Route
              path="views/:clientViewId/communities/:communityId/preview"
              element={<ClientCommunityPreviewPage />}
            />
            <Route
              path="views/:clientViewId/communities/:communityId"
              element={<ClientCommunityDetailPage />}
            />
            <Route path="views/:clientViewId/courses" element={<ClientCoursesListPage />} />
            <Route path="views/:clientViewId/courses/new" element={<ClientCourseFormPage />} />
            <Route
              path="views/:clientViewId/courses/:courseId/edit"
              element={<ClientCourseFormPage />}
            />
            <Route
              path="views/:clientViewId/courses/:courseId/preview"
              element={<ClientCoursePreviewPage />}
            />
            <Route path="views/:clientViewId/courses/:courseId" element={<ClientCourseDetailPage />} />
            <Route
              path="views/:clientViewId/reports/communities"
              element={<ClientCommunityReportPage />}
            />
            <Route path="views/:clientViewId/reports/courses" element={<ClientCourseReportPage />} />
            <Route path="views/:clientViewId/realtors-vendors" element={<ClientRealtorsVendorsPage />} />
            <Route
              path="views/:clientViewId/servicios/*"
              element={<ClientVendorDirectoryHubPage />}
            />
            <Route
              path="views/:clientViewId/realtors-vendors/:vendorId"
              element={<ClientVendorDetailPage />}
            />
            <Route path="views/:clientViewId/publishing" element={<ClientPublishingPage />} />
          </>
        )}
        <Route path="views/:clientViewId/analytics" element={<ClientAnalyticsPage />} />
        <Route path="views/:clientViewId/reports" element={<ClientReportsHubPage />} />
        <Route
          path="views/:clientViewId/reports/opportunities"
          element={<ClientOpportunityReportPage />}
        />
        <Route path="views/:clientViewId/reports/sources" element={<ClientSourceReportPage />} />
        <Route
          path="views/:clientViewId/opportunities"
          element={isCasaMapaPortal ? <CasaMapaAdminLeadsPage /> : <ClientOpportunitiesListPage />}
        />
        <Route
          path="views/:clientViewId/opportunities/:opportunityId"
          element={<ClientOpportunityDetailPage />}
        />
        <Route path="views/:clientViewId/settings/*" element={<ClientSettingsHubLayout />}>
          <Route index element={<ClientSettingsPage />} />
          <Route path="data-sources" element={<ClientSettingsDataSourcesPage />} />
          <Route path="notifications" element={<ClientSettingsNotificationsPage />} />
          <Route
            path="notifications/:templateKey"
            element={<ClientSettingsNotificationEditorPage />}
          />
          <Route path="audit" element={<ClientSettingsAuditPage />} />
        </Route>
      </Route>
    </>
  );
}

export function LegacyClientAdminPortalRoutes() {
  return ClientAdminPortalRouteGroup(CLIENT_ADMIN_PORTAL_LEGACY_BASE);
}

export function CasaMapaAdminPortalRoutes() {
  return ClientAdminPortalRouteGroup(CASAMAPA_ADMIN_PORTAL_BASE);
}

export function MidpointMediaAdminPortalRoutes() {
  return ClientAdminPortalRouteGroup(MIDPOINT_MEDIA_ADMIN_PORTAL_BASE);
}
